"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import Link from "next/link";
import { ArrowRight, Search, Mail, FileText, Calendar } from "lucide-react";
import { Button } from "~/components/ui/button";
import { AiSummaryDemo } from "~/app/_components/ai-summary-demo";
import { Badge } from "~/components/ui/badge";
import { useTranslations } from "next-intl";
import { isPricingEnabledClient } from "~/lib/pricing";
export function HeroSection() {
  const $ = _c(136);
  const t = useTranslations("landing.hero");
  const tLayout = useTranslations("layout");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      hidden: t0,
      show: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
          delayChildren: 0.3
        }
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const container = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hidden: {
        opacity: 0,
        y: 20
      },
      show: {
        opacity: 1,
        y: 0
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const item = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0"><div className="absolute top-0 left-0 h-full w-full bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(45,212,191,0.15),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(20,184,166,0.3),rgba(0,0,0,0))]" /><div className="absolute top-0 right-0 h-full w-full bg-[radial-gradient(ellipse_80%_80%_at_80%_-20%,rgba(59,130,246,0.15),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_80%_80%_at_80%_-20%,rgba(59,130,246,0.3),rgba(0,0,0,0))]" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 20
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t("badge");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <Badge variant="outline" className="mb-6 rounded-full border-teal-200 bg-teal-50 px-4 py-1.5 text-sm text-teal-700 dark:border-teal-900 dark:bg-teal-950/30 dark:text-teal-400">{t7}</Badge>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t.rich("title", {
      gradient: _temp
    });
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <h1 className="mb-6 text-3xl leading-tight font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl dark:text-white">{t9}</h1>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t.rich("description", {
      br: _temp2
    });
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-600 dark:text-gray-300">{t11}</p>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t) {
    t13 = isPricingEnabledClient() ? <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-x-6"><Link href="/auth/signin"><Button size="lg" className="h-12 w-full rounded-full border-none bg-gradient-to-r from-blue-600 to-teal-400 px-8 text-base text-white shadow-teal-500/20 transition-all hover:scale-105 hover:opacity-90 hover:shadow-lg sm:w-auto">{t("cta.demo")}<ArrowRight className="ml-2 h-4 w-4" /></Button></Link><Link href="/pricing"><Button size="lg" variant="outline" className="h-12 w-full border-gray-200 px-8 text-base hover:bg-gray-100 hover:text-gray-900 sm:w-auto dark:border-gray-800 dark:hover:bg-gray-800 dark:hover:text-white">{t("cta.pricing")}</Button></Link></div> : <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-x-6"><Link href="/waitlist"><Button size="lg" className="h-12 w-full rounded-full border-none bg-gradient-to-r from-blue-600 to-teal-400 px-8 text-base text-white shadow-teal-500/20 transition-all hover:scale-105 hover:opacity-90 hover:shadow-lg sm:w-auto">{t("cta.waitlist") || "Join the Waitlist"}<ArrowRight className="ml-2 h-4 w-4" /></Button></Link></div>;
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t12 || $[23] !== t13 || $[24] !== t8) {
    t14 = <motion.div initial={t4} animate={t5} transition={t6} className="mx-auto mb-16 max-w-4xl text-center">{t8}{t10}{t12}{t13}</motion.div>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex items-center gap-2"><div className="h-3 w-3 rounded-full bg-red-400/80" /><div className="h-3 w-3 rounded-full bg-yellow-400/80" /><div className="h-3 w-3 rounded-full bg-green-400/80" /></div>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t) {
    t16 = t("bento.ai");
    $[27] = t;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <div className="absolute top-0 right-0 left-0 z-10 flex items-center justify-between border-b border-white/20 bg-white/40 p-4 backdrop-blur-md dark:bg-black/20">{t15}<div className="text-xs font-medium text-gray-500 dark:text-gray-400">{t16}</div></div>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="absolute inset-0 top-16 bottom-0 flex flex-col justify-end overflow-hidden px-6 pb-6"><div className="w-full scale-100 lg:origin-top lg:scale-90"><AiSummaryDemo /></div></div>;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t17) {
    t19 = <motion.div variants={item} className="relative col-span-1 h-[500px] lg:col-span-7 lg:h-full"><div className="absolute inset-0 h-full w-full overflow-hidden rounded-2xl border border-white/50 bg-gradient-to-br from-teal-50 to-blue-50 shadow-2xl shadow-teal-500/10 dark:border-white/10 dark:bg-gray-900">{t17}{t18}</div></motion.div>;
    $[32] = t17;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"><FileText className="h-5 w-5" /></div>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t) {
    t21 = t("bento.rag.title");
    $[35] = t;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <h3 className="leading-tight font-bold text-gray-900 dark:text-white">{t21}</h3>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t) {
    t23 = t("bento.rag.description");
    $[39] = t;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t23) {
    t24 = <p className="text-xs text-gray-500 dark:text-gray-400">{t23}</p>;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t22 || $[44] !== t24) {
    t25 = <div className="flex items-center gap-3">{t20}<div className="flex flex-col">{t22}{t24}</div></div>;
    $[43] = t22;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t) {
    t26 = t("bento.rag.badge");
    $[46] = t;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== t26) {
    t27 = <div className="shrink-0"><div className="focus:ring-ring inline-flex items-center rounded-md border border-transparent bg-blue-50 px-2.5 py-0.5 text-xs font-semibold text-blue-700 transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none dark:bg-blue-900/50 dark:text-blue-300">{t26}</div></div>;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t25 || $[51] !== t27) {
    t28 = <div className="relative z-10 flex items-start justify-between gap-4">{t25}{t27}</div>;
    $[50] = t25;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="absolute inset-0 z-10 h-full w-full translate-x-[-100%] animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/50 to-transparent" />;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="relative -mx-6 mt-2 -mb-6 flex grow items-end pt-4">{t29}<div className="flex w-full items-center gap-2 border-t border-gray-100 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800"><Search className="h-4 w-4 text-gray-400" /><div className="h-2 w-32 rounded bg-gray-200 dark:bg-gray-700" /></div></div>;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== t28) {
    t31 = <motion.div variants={item} className="flex-1"><div className="group relative flex h-auto min-h-[160px] w-full flex-col justify-between overflow-hidden rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-200/50 transition-all ring-inset hover:shadow-md lg:h-full dark:bg-gray-900 dark:ring-white/10">{t28}{t30}</div></motion.div>;
    $[55] = t28;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400"><Calendar className="h-5 w-5" /></div>;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] !== t) {
    t33 = t("bento.calendar.title");
    $[58] = t;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t33) {
    t34 = <h3 className="leading-tight font-bold text-gray-900 dark:text-white">{t33}</h3>;
    $[60] = t33;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t) {
    t35 = t("bento.calendar.description");
    $[62] = t;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t35) {
    t36 = <p className="text-xs text-gray-500 dark:text-gray-400">{t35}</p>;
    $[64] = t35;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t34 || $[67] !== t36) {
    t37 = <div className="flex items-center gap-3">{t32}<div className="flex flex-col">{t34}{t36}</div></div>;
    $[66] = t34;
    $[67] = t36;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] !== t) {
    t38 = t("bento.calendar.badge");
    $[69] = t;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t38) {
    t39 = <div className="shrink-0"><div className="focus:ring-ring inline-flex items-center rounded-md border border-transparent bg-purple-50 px-2.5 py-0.5 text-xs font-semibold text-purple-700 transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none dark:bg-purple-900/50 dark:text-purple-300">{t38}</div></div>;
    $[71] = t38;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t37 || $[74] !== t39) {
    t40 = <div className="relative z-10 flex items-start justify-between gap-4">{t37}{t39}</div>;
    $[73] = t37;
    $[74] = t39;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="h-8 w-1 rounded-full bg-purple-500" />;
    $[76] = t41;
  } else {
    t41 = $[76];
  }
  let t42;
  if ($[77] !== t) {
    t42 = t("bento.calendar.event1");
    $[77] = t;
    $[78] = t42;
  } else {
    t42 = $[78];
  }
  let t43;
  if ($[79] !== t42) {
    t43 = <div className="text-xs font-semibold text-gray-900 dark:text-white">{t42}</div>;
    $[79] = t42;
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="text-[10px] text-gray-500 dark:text-gray-400">14:00</div>;
    $[81] = t44;
  } else {
    t44 = $[81];
  }
  let t45;
  if ($[82] !== t43) {
    t45 = <div className="flex items-center gap-3 rounded-lg border border-purple-100/50 bg-white p-2 shadow-sm dark:border-purple-900/20 dark:bg-gray-800">{t41}<div>{t43}{t44}</div></div>;
    $[82] = t43;
    $[83] = t45;
  } else {
    t45 = $[83];
  }
  let t46;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="h-8 w-1 rounded-full bg-blue-500" />;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  if ($[85] !== t) {
    t47 = t("bento.calendar.event2");
    $[85] = t;
    $[86] = t47;
  } else {
    t47 = $[86];
  }
  let t48;
  if ($[87] !== t47) {
    t48 = <div className="text-xs font-semibold text-gray-900 dark:text-white">{t47}</div>;
    $[87] = t47;
    $[88] = t48;
  } else {
    t48 = $[88];
  }
  let t49;
  if ($[89] !== tLayout) {
    t49 = tLayout("bento.tomorrow");
    $[89] = tLayout;
    $[90] = t49;
  } else {
    t49 = $[90];
  }
  let t50;
  if ($[91] !== t49) {
    t50 = <div className="text-[10px] text-gray-500 dark:text-gray-400">{t49}</div>;
    $[91] = t49;
    $[92] = t50;
  } else {
    t50 = $[92];
  }
  let t51;
  if ($[93] !== t48 || $[94] !== t50) {
    t51 = <div className="flex items-center gap-3 rounded-lg border border-purple-100/50 bg-white p-2 opacity-60 shadow-sm dark:border-purple-900/20 dark:bg-gray-800">{t46}<div>{t48}{t50}</div></div>;
    $[93] = t48;
    $[94] = t50;
    $[95] = t51;
  } else {
    t51 = $[95];
  }
  let t52;
  if ($[96] !== t45 || $[97] !== t51) {
    t52 = <div className="-mx-6 mt-2 -mb-6 flex grow flex-col justify-end space-y-2 border-t border-purple-100 bg-purple-50/50 p-4 dark:border-purple-900/30 dark:bg-purple-900/10">{t45}{t51}</div>;
    $[96] = t45;
    $[97] = t51;
    $[98] = t52;
  } else {
    t52 = $[98];
  }
  let t53;
  if ($[99] !== t40 || $[100] !== t52) {
    t53 = <motion.div variants={item} className="flex-1"><div className="group relative flex h-auto min-h-[160px] w-full flex-col justify-between overflow-hidden rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-200/50 transition-all ring-inset hover:shadow-md lg:h-full dark:bg-gray-900 dark:ring-white/10">{t40}{t52}</div></motion.div>;
    $[99] = t40;
    $[100] = t52;
    $[101] = t53;
  } else {
    t53 = $[101];
  }
  let t54;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-100 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400"><Mail className="h-5 w-5" /></div>;
    $[102] = t54;
  } else {
    t54 = $[102];
  }
  let t55;
  if ($[103] !== t) {
    t55 = t("bento.email.title");
    $[103] = t;
    $[104] = t55;
  } else {
    t55 = $[104];
  }
  let t56;
  if ($[105] !== t55) {
    t56 = <h3 className="leading-tight font-bold text-gray-900 dark:text-white">{t55}</h3>;
    $[105] = t55;
    $[106] = t56;
  } else {
    t56 = $[106];
  }
  let t57;
  if ($[107] !== t) {
    t57 = t("bento.email.description");
    $[107] = t;
    $[108] = t57;
  } else {
    t57 = $[108];
  }
  let t58;
  if ($[109] !== t57) {
    t58 = <p className="text-xs text-gray-500 dark:text-gray-400">{t57}</p>;
    $[109] = t57;
    $[110] = t58;
  } else {
    t58 = $[110];
  }
  let t59;
  if ($[111] !== t56 || $[112] !== t58) {
    t59 = <div className="flex items-center gap-3">{t54}<div className="flex flex-col">{t56}{t58}</div></div>;
    $[111] = t56;
    $[112] = t58;
    $[113] = t59;
  } else {
    t59 = $[113];
  }
  let t60;
  if ($[114] !== t) {
    t60 = t("bento.email.badge");
    $[114] = t;
    $[115] = t60;
  } else {
    t60 = $[115];
  }
  let t61;
  if ($[116] !== t60) {
    t61 = <div className="shrink-0"><div className="focus:ring-ring inline-flex items-center rounded-md border border-transparent bg-teal-50 px-2.5 py-0.5 text-xs font-semibold text-teal-700 transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none dark:bg-teal-900/50 dark:text-teal-300">{t60}</div></div>;
    $[116] = t60;
    $[117] = t61;
  } else {
    t61 = $[117];
  }
  let t62;
  if ($[118] !== t59 || $[119] !== t61) {
    t62 = <div className="relative z-10 flex items-start justify-between gap-4">{t59}{t61}</div>;
    $[118] = t59;
    $[119] = t61;
    $[120] = t62;
  } else {
    t62 = $[120];
  }
  let t63;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-[10px] font-bold text-gray-500 dark:bg-gray-700 dark:text-gray-400">JD</div>;
    $[121] = t63;
  } else {
    t63 = $[121];
  }
  let t64;
  if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <div className="min-w-0 flex-1"><div className="mb-1.5 h-2 w-20 rounded bg-gray-200 dark:bg-gray-700" /><div className="h-1.5 w-full rounded bg-gray-100 dark:bg-gray-800" /></div>;
    $[122] = t64;
  } else {
    t64 = $[122];
  }
  let t65;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <div className="-mx-6 mt-2 -mb-6 flex grow flex-col justify-end border-t border-teal-100 bg-teal-50/50 p-4 dark:border-teal-900/30 dark:bg-teal-900/10"><div className="flex items-center gap-3 rounded-lg border border-teal-100/50 bg-white p-3 shadow-sm dark:border-teal-900/20 dark:bg-gray-800">{t63}{t64}<div className="flex h-6 w-6 items-center justify-center rounded-full bg-teal-100 dark:bg-teal-900/50"><ArrowRight className="h-3 w-3 text-teal-600 dark:text-teal-400" /></div></div></div>;
    $[123] = t65;
  } else {
    t65 = $[123];
  }
  let t66;
  if ($[124] !== t62) {
    t66 = <motion.div variants={item} className="flex-1"><div className="group relative flex h-auto min-h-[160px] w-full flex-col justify-between overflow-hidden rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-200/50 transition-all ring-inset hover:shadow-md lg:h-full dark:bg-gray-900 dark:ring-white/10">{t62}{t65}</div></motion.div>;
    $[124] = t62;
    $[125] = t66;
  } else {
    t66 = $[125];
  }
  let t67;
  if ($[126] !== t31 || $[127] !== t53 || $[128] !== t66) {
    t67 = <div className="flex h-full flex-col gap-4 lg:col-span-5">{t31}{t53}{t66}</div>;
    $[126] = t31;
    $[127] = t53;
    $[128] = t66;
    $[129] = t67;
  } else {
    t67 = $[129];
  }
  let t68;
  if ($[130] !== t19 || $[131] !== t67) {
    t68 = <motion.div variants={container} initial="hidden" animate="show" className="grid h-auto grid-cols-1 gap-6 lg:h-[600px] lg:max-h-[600px] lg:grid-cols-12">{t19}{t67}</motion.div>;
    $[130] = t19;
    $[131] = t67;
    $[132] = t68;
  } else {
    t68 = $[132];
  }
  let t69;
  if ($[133] !== t14 || $[134] !== t68) {
    t69 = <section className="relative overflow-hidden pt-24 pb-16 lg:pt-32 lg:pb-24">{t3}<div className="container mx-auto px-4">{t14}{t68}</div></section>;
    $[133] = t14;
    $[134] = t68;
    $[135] = t69;
  } else {
    t69 = $[135];
  }
  return t69;
}
function _temp2() {
  return <br />;
}
function _temp(chunks) {
  return <span className="bg-brand-text-gradient animate-gradient-x bg-[length:200%_auto] bg-clip-text text-transparent">{chunks}</span>;
}